// Performance monitoring and Web Vitals tracking
export const trackWebVitals = () => {
  if (typeof window !== 'undefined' && 'performance' in window) {
    // Track Largest Contentful Paint (LCP)
    const trackLCP = () => {
      try {
        const observer = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const lastEntry = entries[entries.length - 1];
          
          if (lastEntry && window.gtag) {
            window.gtag('event', 'web_vitals', {
              event_category: 'Web Vitals',
              event_label: 'LCP',
              value: Math.round(lastEntry.startTime)
            });
          }
        });
        
        observer.observe({ entryTypes: ['largest-contentful-paint'] });
      } catch (error) {
        console.warn('LCP tracking failed:', error);
      }
    };

    // Track First Input Delay (FID)
    const trackFID = () => {
      try {
        const observer = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          
          entries.forEach((entry) => {
            if (entry.processingStart && window.gtag) {
              const fid = entry.processingStart - entry.startTime;
              window.gtag('event', 'web_vitals', {
                event_category: 'Web Vitals',
                event_label: 'FID',
                value: Math.round(fid)
              });
            }
          });
        });
        
        observer.observe({ entryTypes: ['first-input'] });
      } catch (error) {
        console.warn('FID tracking failed:', error);
      }
    };

    // Track Cumulative Layout Shift (CLS)
    const trackCLS = () => {
      try {
        let clsValue = 0;
        let clsEntries = [];
        
        const observer = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          
          entries.forEach((entry) => {
            if (!entry.hadRecentInput) {
              clsValue += entry.value;
              clsEntries.push(entry);
            }
          });
          
          if (window.gtag) {
            window.gtag('event', 'web_vitals', {
              event_category: 'Web Vitals',
              event_label: 'CLS',
              value: Math.round(clsValue * 1000)
            });
          }
        });
        
        observer.observe({ entryTypes: ['layout-shift'] });
      } catch (error) {
        console.warn('CLS tracking failed:', error);
      }
    };

    // Initialize tracking
    trackLCP();
    trackFID();
    trackCLS();
  }
};

// Monitor third-party script loading
export const monitorThirdPartyScripts = () => {
  if (typeof window !== 'undefined') {
    const thirdPartyDomains = [
      'google.com',
      'googleapis.com',
      'gstatic.com',
      'googletagmanager.com'
    ];

    // Monitor resource loading times
    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      
      entries.forEach((entry) => {
        if (entry.name && thirdPartyDomains.some(domain => entry.name.includes(domain))) {
          const loadTime = entry.responseEnd - entry.startTime;
          
          if (window.gtag && loadTime > 1000) { // Only track slow loads (>1s)
            window.gtag('event', 'third_party_performance', {
              event_category: 'Performance',
              event_label: new URL(entry.name).hostname,
              value: Math.round(loadTime)
            });
          }
        }
      });
    });

    try {
      observer.observe({ entryTypes: ['resource'] });
    } catch (error) {
      console.warn('Third-party script monitoring failed:', error);
    }
  }
};

// Track console errors for analytics
export const trackConsoleErrors = () => {
  if (typeof window !== 'undefined') {
    const originalError = console.error;
    
    console.error = (...args) => {
      const message = args.join(' ');
      
      // Don't track extension errors
      const isExtensionError = message.includes('extension://') || 
                             message.includes('share-modal.js');
      
      if (!isExtensionError && window.gtag) {
        window.gtag('event', 'javascript_error', {
          event_category: 'Error',
          event_label: message.substring(0, 100), // Limit length
          non_interaction: true
        });
      }
      
      originalError.apply(console, args);
    };
  }
};